module.exports = __webpack_public_path__ + "img/asura_f.cb0a7613.png";